import { useLocation, Navigate, Outlet } from 'react-router-dom';

import LoadingScreen from 'components/molecules/LoadingScreen';
import useReactQuery from 'hooks/common/useReactQuery';
import { Agreements } from 'interfaces/agreement';

const RequireAgreement: React.FC = () => {
  const location = useLocation();
  const { useQuery } = useReactQuery();

  const queryParams = new URLSearchParams({
    display_code: 'for_parents',
  });

  const { data, isPending } = useQuery<Agreements>({
    queryKey: ['agreements'],
    url: `/api/school_communication/agreements?${queryParams.toString()}`,
  });

  const agreements = data?.agreements ?? [];

  const isAgreed =
    agreements.length > 0 && agreements.every((a) => a.agreement);

  if (isPending) {
    return <LoadingScreen />;
  }

  if (!isAgreed) {
    return (
      <Navigate
        replace
        to="/agreements"
        state={{
          redirectTo: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
        }}
      />
    );
  }

  return <Outlet />;
};

export default RequireAgreement;
